export enum UserProfileStepIds {
  USER_INFO = 'userinfo',
  USER_PERMISSIONS = 'permissions',
  USER_NOTIFICATIONS = 'notifications',
  USER_AUDIT = 'audit',
  USER_TRAINING = 'training'
}